import { CommonResponse } from 'models';
import axiosClient from 'utils/axiosClient';
import { UploadVideoResponse } from './model';

const videoUploadModalService = {
  uploadVideo(payload: FormData): Promise<CommonResponse<UploadVideoResponse>> {
    const url = '/upload-video';
    return axiosClient.put(url, payload, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
};

export default videoUploadModalService;
